import { render, staticRenderFns } from "./TabNominatorList.vue?vue&type=template&id=33d3e27c"
import script from "./TabNominatorList.vue?vue&type=script&lang=js"
export * from "./TabNominatorList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports